import { render } from "./TemaKundensForretning.vue?vue&type=template&id=10992ed8&scoped=true"
import script from "./TemaKundensForretning.vue?vue&type=script&lang=js"
export * from "./TemaKundensForretning.vue?vue&type=script&lang=js"

import "./TemaKundensForretning.vue?vue&type=style&index=0&id=10992ed8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10992ed8"]])

export default __exports__